import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import apiClient from '@app/network/apiClient';
import Lang from '@lang/en';
import { healthCheckOrderDetailsUrl } from '@app/definition/API';
import {
  CustomErrorCallInterface,
  getErrorMessage,
} from '@app/common/form/getErrorMessage';
import showNotification from '@root/src/app/designSystem/toastNotification/selectToast';

const useDeleteOrder = (): {
  deleteOrder: (orderId: number) => Promise<void>;
  error: string | null;
  isDeleted: boolean;
  setError: (value: string) => void;
} => {
  const history = useHistory();
  const [error, setError] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);

  const deleteOrder = useCallback(
    async (orderId: number) => {
      setError('');
      setIsDeleted(false);

      try {
        const url = healthCheckOrderDetailsUrl.replace('%id%', String(orderId));
        const response = await apiClient.delete(url);

        if (response.status >= 400) {
          const error = new Error(Lang.invalidResponse);
          (error as CustomErrorCallInterface).response = response.data;
          throw error;
        }
        history.push('/dashboard');
        showNotification({
          text: Lang.healthCheckDeleteOrderSuccessfully,
          type: 'success',
        });

        setIsDeleted(true);
      } catch (err) {
        const errorMessage = getErrorMessage(err as CustomErrorCallInterface);
        setError(errorMessage);
        showNotification({
          text: Lang.healthCheckCouldNotDeleteError,
          type: 'error',
        });
      }
    },
    [history]
  );

  return { deleteOrder, error, isDeleted, setError };
};

export default useDeleteOrder;
